import React from "react";
import Price from "../../components/Service/price";
import Cards from "../../components/Service/cards";
import Map from "../../components/Service/map";
import "../../assets/styles/cards.css";
import { FaChevronDown } from "react-icons/fa";
import Logo from "../../assets/images/logo/321VETS_LOGO.png";
import { useLocation } from "react-router-dom"; 

const GeneralVeterinaryPage = () => {
  const location = useLocation();
const route = location.pathname.split("/")[2]; 
  return (
    <>
      <div className="location-1">
        <a href="/">
          <img src={Logo} width={100} alt="321 bets" />
        </a>
        <div className="custom-select-wrapper">
          <FaChevronDown className="custom-select-icon" />
          <select className="custom-select">
            <option value="Hospital">Vet Hospital Near Me</option>
          </select>
        </div>
        <div className="custom-select-wrapper">
          <FaChevronDown className="custom-select-icon" />
          <select className="custom-select">
            <option value="Practice">General Practice</option>
          </select>
        </div>
      </div>

      <div className="main-home">
      <Price route={route} />
        <Cards />
        <Map />
      </div>
    </>
  );
};

export default GeneralVeterinaryPage;
